import script from "./TwoFactorAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorAuth.vue?vue&type=style&index=0&id=dcf825b0&lang=css"

const __exports__ = script;

export default __exports__